import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./skills-skeleton.css";

const SkillsSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.5 },
    visible: { opacity: 1 },
  };

  return (
    <motion.section
      className="skills section"
      id="skills"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      {/* Title and Subtitle */}
      <motion.h2
        className="section__title skeleton-title-large"
        variants={itemVariants}
      />
      <motion.span
        className="section__subtitle skeleton-subtitle"
        variants={itemVariants}
      />

      {/* Filter Nav Skeleton */}
      <motion.div className="skills__controlsRow" variants={itemVariants}>
        <div>
          <div className="skeleton-filters-group">
            {[1, 2, 3, 4, 5].map((_, idx) => (
              <motion.div
                key={idx}
                variants={itemVariants}
                className="skeleton-filter-item"
              />
            ))}
          </div>
        </div>
        <motion.div variants={itemVariants} className="skeleton-nav-add-btn" />
      </motion.div>

      {/* Skills Chips Container */}
      <motion.div
        className="skills__container container"
        variants={itemVariants}
      >
        <div className="skeleton-chips-group">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((_, idx) => (
            <motion.div
              key={idx}
              variants={itemVariants}
              className="skeleton-chip-item"
            />
          ))}
        </div>
      </motion.div>
    </motion.section>
  );
};

export default SkillsSkeleton;
